module.exports = __webpack_public_path__ + "static/img/service2.57d026ef.png";